import http from '@/services/http';

const departmentDefaultLocations = {
  index() {
    return http.request({
      method: 'get',
      url: '/department-default-locations',
    });
  },
  count() {
    return http.request({
      method: 'get',
      url: '/department-default-locations/count',
    });
  },
  create(data) {
    return http.request({
      method: 'post',
      url: '/department-default-locations',
      data,
    });
  },
  patch(id, data) {
    return http.request({
      method: 'patch',
      url: `/department-default-locations/${id}`,
      data,
    });
  },
  delete(id) {
    return http.request({
      method: 'delete',
      url: `/department-default-locations/${id}`,
    });
  },
};

export default departmentDefaultLocations;
